import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import {ListPopSize } from './Propertyfile';

  const apiSessionId = sessionStorage.getItem("sessionId");
  console.log("sessionId", apiSessionId);

export const Modalpopup = ({ showModal, modalMessage, goBack }) => {
    const navigate = useNavigate();

    const closeButtonStyle = {
        color: 'white',
        border: 'none'
    };


    // const goBack = () => {
    //     navigate(-1);
    // };

    return (
        <Modal show={showModal} onHide={goBack} centered>
            <Modal.Header closeButton>
                <Modal.Title>Notification</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p style={ListPopSize}>{modalMessage}</p>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" style={closeButtonStyle} onClick={goBack}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export const responsefunction = (response, setModalMessage, setShowModal, setTableNames, message) => {
    if (response.data.masters === null) {
        setModalMessage(message); // Use the passed message
        setShowModal(true);
    } else {
        setTableNames(response.data.masters); // Populate table names if not null
    }
};

export const responseRDM = (response, setModalMessage, setShowModal, setTableNames, message) => {
    if (response.data.MASTERS === null) {
        setModalMessage(message); // Use the passed message
        setShowModal(true);
    } else {
        setTableNames(response.data.MASTERS); // Populate table names if not null
    }
};

export const responsebkm = (response, setModalMessage, setShowModal, setBackupTables, message) => {
    if (response.data.backupTables === null) {
        setModalMessage(message); // Use the passed message
        setShowModal(true);
    } else {
        setBackupTables(response.data.backupTables); // Populate table names if not null
    }
};

export const responseDEMBKP = (response, setModalMessage, setShowModal, setTableNames, message) => {
    if (response.data.tableList === null) {
        setModalMessage(message); // Use the passed message
        setShowModal(true);
    } else {
        setTableNames(response.data.tableList); // Populate table names if not null
    }
};

export const responseDEMBKP1 = (response, setModalMessage, setShowModal, setTableNames, message) => {
    if (response.data.BDM === null) {
        setModalMessage(message); // Use the passed message
        setShowModal(true);
    } else {
        setTableNames(response.data.BDM); // Populate table names if not null
    }
};


export const responseMaker1 = (response, setModalMessage, setShowModal, setTableNames, message) => {
    if (response.data.tableList === null) {
        setModalMessage(message); // Use the passed message
        setShowModal(true);
    } else {
        setTableNames(response.data.tableList); // Populate table names if not null
    }
};



export const responseMaker2 = (response, setModalMessage, setShowModal, setTableNames, message) => {
    if (response.data.DEM === null) {
        setModalMessage(message); // Use the passed message
        setShowModal(true);
    } else {
        setTableNames(response.data.DEM); // Populate table names if not null
    }
};


export const responseDEMBKPMaker = (response, setModalMessage, setShowModal, setTableNames, message) => {
    if (response.data.DEM === null) {
        setModalMessage(message); // Use the passed message
        setShowModal(true);
    } else {
        setTableNames(response.data.DEM); // Populate table names if not null
    }
};


export const responseDEMBDMMaker = (response1Tables, response2Tables, setModalMessage, setShowModal, setTableNames, message) => {
    const isBDMNull = response1Tables === null;
    const isTableListNull = response2Tables === null;

    if (isBDMNull && isTableListNull) {
        setModalMessage(message);
        setShowModal(true);
    } else {
        const response1WithFlag = (response1Tables || []).map(tableName => ({
            tableName,
            isRetrieve: true,
        }));

        const response2WithFlag = (response2Tables || []).map(tableName => ({
            tableName,
            isRetrieve: false,
        }));

        const mergedTables = [...response1WithFlag, ...response2WithFlag];
        setTableNames(mergedTables);
    }
};


export const responseDEMRetrieval = (response, setModalMessage, setShowModal, setTableNames, message) => {
    if (response.data.tableList === null) {
        setModalMessage(message); // Use the passed message
        setShowModal(true);
    } else {
        setTableNames(response.data.tableList); // Populate table names if not null
    }
};



export const responseDEM = (response, setModalMessage, setShowModal, setTableNames, message) => {
    if (response.data.tableList === null) {
        setModalMessage(message); // Use the passed message
        setShowModal(true);
    } else {
        setTableNames(response.data.tableList); // Populate table names if not null
    }
};

export const responseBKP = (response, setModalMessage, setShowModal, setTableNames, message) => {
    if (response.data.tables === null) {
        setModalMessage(message); // Use the passed message
        setShowModal(true);
    } else {
        setTableNames(response.data.tables); // Populate table names if not null
    }
};

export const responsemodify = (response, setModalMessage, setShowModal, setTableNames, message) => {
    if (response.data.tableList === null) {
        setModalMessage(message); // Use the passed message
        setShowModal(true);
    } else {
        setTableNames(response.data.tableList); // Populate table names if not null
    }
};

export const responseBDMBKP = (response, setModalMessage, setShowModal, setTableNames, message) => {
    if (response.data.BDM === null) {
        setModalMessage(message); // Use the passed message
        setShowModal(true);
    } else {
        setTableNames(response.data.BDM); // Populate table names if not null
    }
};
// export const responseModify = (response, setModalMessage, setShowModal, setTableNames, message) => {
//     if (response.data.tables === null) {
//         setModalMessage(message); // Use the passed message
//         setShowModal(true);
//     } else {
//         setTableNames(response.data.tables); // Populate table names if not null
//     }
// };

export const responseModify = (response, setModalMessage, setShowModal, setTableNames, message) => {
    console.log("API Response:", response); // Debug API response

    if (!response.data || !response.data.tables || response.data.tables.length === 0) {
        console.log("No tables found in response.");
        setModalMessage(message);
        setShowModal(true);
    } else {
        console.log("Setting Table Names:", response.data.tables);
        setTableNames(response.data.tables); // Populate table names if not null
    }
};

export const responseRDMModify = (response, setModalMessage, setShowModal, setTableNames, message) => {
    if (!response.data.masters || response.data.masters === "Null") {
        setModalMessage(message);
        setShowModal(true);
    } else {
        // Ensure tableNames is an array
        setTableNames(response.data.masters || []);
    }
};

export const responseRDMModifyRejection = (response, setModalMessage, setShowModal, setTableNames, message) => {
    if (!response.data.tablename || response.data.message === "Null") {
        setModalMessage(message);
        setShowModal(true);
    } else {
        // Ensure tableNames is an array
        setTableNames(response.data.tablename);
    }
};

export default Modalpopup;


